module.exports = __webpack_public_path__ + "static/media/loader.e4b6323e.gif";